import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import "../App.css";
import Flag from "../assets/images/flag.png";
import { toast } from "react-toastify";
import { forgotPassword, ownerLogin } from "../redux/actions/authAction";
import Logo from "../assets/images/bayin.png";
const initialState = {
    email: "",
    newPassword: "",
    compareNewPassword: "",
    errors: {},
}

const ChangePassword = () => {
    let [showPassword, setShowPassword] = useState(true);
    let [showConfirmPassword, setShowConfirmPassword] = useState(true);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [iState, updateState] = useState(initialState);
    const { email, newPassword, compareNewPassword, errors } = iState;
    const handleChange = (e) => {
        const { name, value } = e.target;
        updateState({
            ...iState,
            [name]: value,
        })
    }
    const emailId = JSON.parse(localStorage.getItem("emailId"));
    let handleValidation = () => {
        let error = {};
        let formIsValid = true;

        if (!newPassword.trim()) {
            error.newPasswordEmpty = "* New Password can't be empty";
            formIsValid = false;
        }
        if (!compareNewPassword.trim()) {
            error.compareEmpty = " * Confirm Password can't be empty";
            formIsValid = false;
        }
        updateState({
            ...iState,
            errors: error,
        });
        return formIsValid;
    };

    const handleForgotPassword = (e) => {
        e.preventDefault();
        let formIsValid = handleValidation();
        if (formIsValid) {
            let data = { newPassword, email: emailId };
            dispatch(forgotPassword(data)).then((res) => {
                if (res.status === 200) {
                    navigate("/successful");
                    toast.success(res.message, {
                        position: toast.POSITION.TOP_RIGHT,
                    });
                    updateState(initialState);

                } else {
                    toast.error(res.message, {
                        position: toast.POSITION.TOP_RIGHT,
                    });
                }
            });
        }
    };


    return (
        <div className="LoginArea" >
            <span className="BackButton">
                <Link to="/ " > <i className="fa fa-long-arrow-left" aria-hidden="true"></i></Link>Back To Login
            </span>
            <div className="LoginBox">
                <figure>
                    <img src={Logo} />
                </figure>
                <span className="Language">
                    <aside>
                        <img src={Flag} />
                    </aside>
                    <select className="form-control">
                        <option>English</option>
                        <option>Arabic</option>
                    </select>
                </span>
                <h3>Confirm your Password? </h3>
                <h4>No Problem! Enter your new password</h4>
                <form onSubmit={handleForgotPassword}>
                    <div className="form-group">
                        <label>Password</label>
                        <input type={showPassword ? "password" : "text"} className="form-control" placeholder="New Password" name="newPassword" value={newPassword} onChange={handleChange} />
                        <span onClick={(e) => { setShowPassword(!showPassword); }}>
                            {showPassword ? (
                                <span className="Icon"><i className="fa fa-eye"></i></span>
                            ) : (
                                <span className="Icon cross"><i className="fa fa-eye"></i></span>
                            )}
                        </span>
                        <span style={{ color: "red", fontSize: "12px" }}>{errors.newPasswordEmpty}</span>
                    </div>
                    <div className="form-group">
                        <label>Confirm Password</label>
                        <input type={showConfirmPassword ? "password" : "text"} className="form-control" placeholder="Confirm Password" name="compareNewPassword" value={compareNewPassword} onChange={handleChange} />
                        <span onClick={(e) => { setShowConfirmPassword(!showConfirmPassword); }}>
                            {showConfirmPassword ? (
                                <span className="Icon"><i className="fa fa-eye"></i></span>
                            ) : (
                                <span className="Icon cross"><i className="fa fa-eye"></i></span>
                            )}
                        </span>
                        <span style={{ color: "red", fontSize: "12px" }}>{errors.compareEmpty}</span>
                    </div>
                    <button>Create Password</button>
                    {/* <Link to="/successful" className="Button">Create Password</Link> */}
                </form>
            </div>
        </div >
    );
}
export default ChangePassword